import { __assign, __awaiter, __generator } from "tslib";
import React from "react";
import { Avatar } from "@hose/eui";
import { NameCell } from "../name-cell";
import { app } from "@ekuaibao/whispered";
export var StaffItemInWeComISV = function (_a) {
    var staff = _a.staff, _b = _a.avatarStyle, avatarStyle = _b === void 0 ? {} : _b;
    return (React.createElement(React.Fragment, null,
        React.createElement(Avatar, { shape: "circle", size: "small", style: __assign({ marginRight: 4, width: 16, height: 16, lineHeight: '16px', border: '1px solid white', marginBottom: 2 }, avatarStyle) }),
        React.createElement(NameCell, { type: "user", id: staff.id, name: "" })));
};
export var queryStaffDataInWeComISV = function (searchKey) { return __awaiter(void 0, void 0, void 0, function () {
    var userIds;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4, app.invokeService('@organizationManagement:search:wecom:staffs', searchKey)];
            case 1:
                userIds = _a.sent();
                return [2, {
                        items: userIds.map(function (id) { return ({
                            id: id,
                            name: '',
                            active: true,
                        }); })
                    }];
        }
    });
}); };
